import React from "react";
import Message from "carbon-react/lib/components/message";

import "./Message.css";

const InfoMessage = (props) => {
  const dismissVisible =
    props.onDismiss && typeof props.onDismiss === "function";

  return (
    <Message
      className="message-banner"
      as="info"
      border
      id={props.id || "infoMessageId"}
      open
      roundedCorners
      {...(dismissVisible
        ? {
            onDismiss: () => {
              props.onDismiss();
            },
          }
        : {})}
      {...(dismissVisible ? { showCloseIcon: true } : {})}
    >
      {props.message}
    </Message>
  );
};

export default InfoMessage;
